import Cookies from 'js-cookie'
import { Base64 } from 'js-base64'

class CookiesUtils {
  private static readonly sidebarStatusKey = 'sidebar_status'
  private static readonly tokenKey = 'family_cloud_access_token'
  private static readonly loginKey = 'family_cloud_login_info'
  private static readonly rolesKey = 'user_auth_roles'
  private static readonly permissionsKey = 'user_info'

  static getSidebarStatus() {
    return Cookies.get(CookiesUtils.sidebarStatusKey)
  }

  static setSidebarStatus(sidebarStatus: string) {
    Cookies.set(CookiesUtils.sidebarStatusKey, sidebarStatus)
  }

  static getToken(): string {
    let token = Cookies.get(CookiesUtils.tokenKey)
    if (!token) {
      token = ''
    } else {
      const timeDiff: any = localStorage.getItem('server-time-diff')
      const timeTrue = timeDiff ? timeDiff * 1000 : 0
      const time = Date.now() + timeTrue
      const dateNumber = parseInt((time / 1000).toString(), 10)
      const dateStr = token + ':' + dateNumber
      token = Base64.encode(dateStr) + ''
    }
    return token
  }

  static setToken(token: string) {
    Cookies.set(CookiesUtils.tokenKey, token)
  }

  static removeToken() {
    Cookies.remove(CookiesUtils.tokenKey)
  }

  static getUser(): string {
    let content = Cookies.get(CookiesUtils.loginKey)
    if (!content) {
      return ''
    }
    return content
  }

  static setUser(user: any) {
    let content = JSON.stringify(user)
    Cookies.set(CookiesUtils.loginKey, content)
  }

  static removeUser() {
    Cookies.remove(CookiesUtils.loginKey)
  }

  static setRoles(roles: any) {
    let content = JSON.stringify(roles)
    localStorage.setItem(CookiesUtils.rolesKey, content)
  }
  static getRoles() {
    try {
      let content = localStorage.getItem(CookiesUtils.rolesKey)
      if (!content) {
        return []
      }
      return JSON.parse(content)
    } catch (error) {
      console.error(error)
      return []
    }
  }
  static removeRoles() {
    console.log('removeRoles')
    localStorage.removeItem(CookiesUtils.rolesKey)
  }

  static setPermissions(permissions: any) {
    let content = JSON.stringify(permissions)
    localStorage.setItem(CookiesUtils.permissionsKey, content)
  }
  static getPermissions() {
    try {
      let content = localStorage.getItem(CookiesUtils.permissionsKey)
      if (!content) {
        return []
      }
      return JSON.parse(content)
    } catch (error) {
      console.error(error)
      return []
    }
  }
  static removePermissions() {
    localStorage.removeItem(CookiesUtils.permissionsKey)
  }
}

export default CookiesUtils
